<!---START: Wizard First Screen-->

  <div>
    <div style="padding: 0px 15px 0px 15px;" class="flex justify-start content-stretch items-stretch flex-col">
      <div appDragDrop class="fileuploaddiv" *ngIf="!fieleSelect" (fileDropped)="onFileDropped($event)"
          style="border:1px dashed #c5c5c5; padding:16px; background:#fafafa; width:100%; box-sizing:border-box;">
        <input type="file" #fileDropRef id="fileDropRef"
              (change)="onFileSelected($event)"
              title="please select only xls and csv files"
              accept=".xlsx, .xls, .csv" />

        <div style="display:flex; flex-wrap:wrap; align-items:flex-start; gap:16px; width:100%;">
          <!-- Icon -->
          <div style="flex:0 0 auto; width:48px; display:flex; justify-content:center; padding-top:4px;">
            <img src="../../../../assets/img/icons/ico.24.export.svg" alt="" style="max-width:32px;">
          </div>

          <!-- Text block -->
          <div style="flex:1 1 320px; min-width:260px; max-width:640px;">
            <p style="margin:0 0 4px 0;">Drag and drop the file you would like to upload</p>
            <label for="fileDropRef" style="font-size:12px; color:#555;">Accepted file formats are .xlsx, .xls, and .csv.</label>
          </div>

          <!-- OR separator -->
          <div style="flex:0 0 auto; align-self:center; font-weight:600; min-width:40px;">
            OR
          </div>

          <!-- Button -->
          <div style="flex:0 0 auto; min-width:210px; display:flex; align-items:center; justify-content:flex-end; margin-left:auto;">
            <button mat-button class="btn-light btn-md btn-done m-l-16"
                    id="OrgChoosen" type="file" aria-label="Browse">
              Browse My Computer
            </button>
          </div>
        </div>
      </div>

      <!-- Excel Preview -->
      <div appDragDrop *ngIf="fieleSelect && percentage==0 && excelPreviewData.length"
          class="excel-preview-container"
          style="margin:16px 15px 10px 15px; border:1px solid #ddd; padding:10px; background:#fff; box-sizing:border-box; width:calc(100% - 30px); overflow-x:auto;">
        <table style="border-collapse:collapse; width:max-content;">
          <tr *ngFor="let row of excelPreviewData; let r = index"
              [ngStyle]="{'background-color': r===0 ? '#f0f0f0' : (r % 2 === 0 ? '#fafafa' : '#fff')}">
            <td *ngFor="let cell of row"
                [ngStyle]="{'border':'1px solid #ccc', 'padding':'6px 10px', 'white-space':'nowrap', 'font-weight': r===0 ? '600' : '400'}">
              {{ cell }}
            </td>
          </tr>
        </table>
      </div>

      <!-- File selected actions -->
      <div appDragDrop class="fileselecteddiv flex file-actions"
          *ngIf="fieleSelect && percentage==0"
          style="margin:0 15px 10px 15px; padding:10px; background:#fff; box-sizing:border-box; width:calc(100% - 30px); flex-wrap:wrap; align-items:center;">
        <mat-icon style="padding-bottom:11px;">
          <img src="/assets/img/icons/ico.24.document.svg" alt="" style="width:34px; margin-top:15px;">
        </mat-icon>

        <span class="selected-file-name truncate"
              style="max-width:300px; display:inline-block; margin-left:10px;" title="{{fielName}}">
          {{ fielName }}
        </span>

        <mat-icon (click)="onRemoveFile()" id="OrgChoosen"
                  class="cursor-pointer ml-2" style="margin-left:12px;">
          <img src="/assets/img/icons/ico.16.trash.svg" alt="" style="color:red;">
        </mat-icon>

        <div *ngIf="fileUploadButtonShow" style="margin-left:20px;">
          <button mat-button class="btn-blue btn-sm btn-done"
                  (click)="fileUpload()" id="OrgChoosen" type="file"
                  aria-label="Upload">Upload</button>
        </div>
      </div>

      <!-- Upload progress -->
      <div appDragDrop class="fileselecteddiv"
          *ngIf="fieleSelect && percentage==100"
          style="margin:16px 15px 10px 15px; padding:10px; background:#fff; box-sizing:border-box; width:calc(100% - 30px);">
        <div class="meter" *ngIf="fieleSelect && percentage>=0">
          <p class="meter-filename" style="margin:0 0 8px 0;"><b>Uploading </b>({{fielName}})</p>
          <span [style.width]="percentage+'%'" [style.background-color]="backgroundcolor"
                style="display:inline-block; height:18px; line-height:18px; text-align:center; transition:width .3s;">
            <b style="font-size:11px; color: white !important;">{{percentage}}%</b>
          </span>
        </div>
      </div>
    </div>

    <form [formGroup]="drugFileInfoForm">

      <mat-dialog-content style="margin: 19px 16px 0px !important; height: 21vw;">


        <div class="drug-checkbox-group">
          <mat-radio-group formControlName="countryId"  (change)="updateTheFormForCountry($event.value)" aria-label="Select a country">
            <mat-radio-button *ngFor="let country of countries" [disabled]="this.columnNameList.length ===
            0" [value]="country.id"  [checked]="country.id == countryId.value" class="radio-button-padding">
              {{ country.countryName }}
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="drug-checkbox-group">
          <mat-radio-group formControlName="deviceId" (change)="updateTheForm($event.value)" aria-label="Select a device">
            <ng-container *ngFor="let device of devices">
              <mat-radio-button 
                *ngIf="device.id !== 7 || isParataLegacyConnectEnabled" 
                [disabled]="this.columnNameList.length === 0" 
                [value]="device.id"  
                [checked]="device.id == deviceId.value" 
                class="radio-button-padding">
                {{ device.deviceName }}
              </mat-radio-button>
            </ng-container>
          </mat-radio-group>
        </div>

        <div class="sub-device flex flex-row" style="margin-bottom: 10px;" *ngIf="isDrugValidationActive()">
          <mat-form-field floatLabel="never" class="sm:basis-[47%] basis-[17.3%]">
            <label for="Data Source" style="display: flex; align-items: center; gap: 4px;">
              <mat-icon class="cross-wizard">
                <img src="/assets/img/icons/ico.asterisk.svg" alt="">
              </mat-icon>
              <span>Data Source</span>
            </label>
            <mat-select formControlName="dataSourceId" *ngIf="countryId.value === 1" (selectionChange)="onDataSourceSelected($event.value)">
              <ng-container *ngFor="let source of datasourceList">
                <mat-option *ngIf="source.value.includes('USA')" [value]="source.key">
                  {{ source.value }}
                  <span class="help_icon" [matTooltip]="source.description" matTooltipPosition="after" matTooltipClass="custom_tooltip">
                    <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
                  </span>
                </mat-option>
              </ng-container>
            </mat-select>
            <mat-select formControlName="dataSourceId" *ngIf="countryId.value===2">
              <mat-option [value]="4">DPD(CAN)
                <span class="help_icon" [matTooltip]="'Preferred data source in the CANADA'" matTooltipPosition="after" matTooltipClass="custom_tooltip">
                  <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
                </span>
              </mat-option>
            </mat-select>
            <mat-error *ngIf="dataSourceId.hasError('required')">Data source required</mat-error>
          </mat-form-field>
        </div>

        <ng-container *ngFor="let device of devices">
          <h6 *ngIf="device.id === deviceId.value" class="m-t-0 m-b-0">Map imported columns to {{device.deviceName}} format</h6>
        </ng-container>

        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 1 || this.deviceId.value === 2 || this.deviceId.value === 3 || this.deviceId.value === 4 || this.deviceId.value === 5 || this.deviceId.value === 6 || this.deviceId.value === 7">
          <span>
            <mat-icon class="cross-wizard">
              <img src="/assets/img/icons/ico.asterisk.svg" alt="">

            </mat-icon>
          </span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedDrugName">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
            <mat-error *ngIf="mappedDrugName.hasError('required')">Drug Name required</mat-error>
          </mat-form-field>

          <span style="padding-left: 6px"> = Drug Name
          </span>
          <span class="help_icon" matTooltip=" This is the name the customer assigns to the drug. this is used as a reference only." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 1 || this.deviceId.value === 2 || this.deviceId.value === 3 || this.deviceId.value === 4 || this.deviceId.value === 5 || this.deviceId.value === 6 || this.deviceId.value === 7">
          <span>
            <mat-icon class="cross-wizard">
              <img src="/assets/img/icons/ico.asterisk.svg" alt="">
            </mat-icon>
          </span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedNDC">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
            <mat-error *ngIf="mappedNDC.hasError('required')">NDC required</mat-error>
          </mat-form-field>
        <span style="padding-left: 6px">= </span>
          <span *ngIf="isDrugValidationActive() || (isParataLegacyConnectEnabled && this.deviceId.value === 7)" class="drug-number-label"> Drug Number </span>
          <span *ngIf="!isDrugValidationActive() && (!isParataLegacyConnectEnabled || deviceId.value !== 7)" class="drug-number-label">
            <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
              <mat-select formControlName="mappedNdcLabel" *ngIf="countryId.value === 1">
                <mat-option *ngFor="let label of ndcLabel" [value]="label.id">{{label.title}}</mat-option>
              </mat-select>
              <mat-select formControlName="mappedNdcLabel" *ngIf="countryId.value===2">
                <mat-option *ngFor="let label of ndcLabelForCanada" [value]="label.id">{{label.title}}</mat-option>
              </mat-select>
            </mat-form-field>
          </span>
          <span *ngIf="countryId.value === 1 && isDrugValidationActive()" class="help_icon" matTooltip="National Drug Code - Used to uniquely identify a drug." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
          <span *ngIf="countryId.value === 1 && !isDrugValidationActive()" class="help_icon" matTooltip="National Drug Code - Used to uniquely identify a drug. Requirements: 11-digit drug codes are required. If the number provided is less than 11 digits, a leading zero is added to compensate for leading zeroes removed by Excel. 10-digit hyphenated formats in 4-4-2, 5-3-2, and 5-4-1 are converted to 11-digit based on sequence." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
          <span *ngIf="countryId.value===2" class="help_icon" matTooltip="Drug Identification Number (DIN) - Used to uniquely identify a drug product in Canada. Requirements: 8-digit DIN is required." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 1 || this.deviceId.value === 2 || this.deviceId.value === 3 || this.deviceId.value === 4 || this.deviceId.value === 5 || this.deviceId.value === 6 || this.deviceId.value === 7">
          <span>
            <mat-icon class="cross-wizard">
              <img *ngIf="deviceId.value !== 7 && (drugFileInfoForm.get('noUsage').value == false || drugFileInfoForm.get('noUsage').value == null)" src="/assets/img/icons/ico.asterisk.svg"
                alt="">
            </mat-icon>
          </span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select (selectionChange)="updateNoUsage()" formControlName="mappedUsage">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
            <mat-error *ngIf="mappedUsage.hasError('required')">Number of required</mat-error>
          </mat-form-field>

          <span style="padding-left: 6px; margin-top: 1px;">
            <mat-radio-group [disabled]="drugFileInfoForm.get('noUsage').value==true" formControlName="orderOrUsage"
              aria-label="Number of Orders">
              <mat-radio-button [value]='1' [checked]="drugFileInfoForm.get('usageValue').value  == 2">
                Prescriptions Usage</mat-radio-button>
              <mat-radio-button style="padding-left: 6px" [checked]="drugFileInfoForm.get('usageValue').value == 1"
                [value]="2" aria-label="Unit Usage"> Pill Usage</mat-radio-button>

            </mat-radio-group>
          </span>
          <span class="help_icon" matTooltip="This is the total number of RXs the pharmacy has filled. Requirements - numeric values only." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>


        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 1 || this.deviceId.value === 2 || this.deviceId.value === 3 || this.deviceId.value === 4 || this.deviceId.value === 5 ||this.deviceId.value === 6 || this.deviceId.value === 7">
          <span>
            <mat-icon class="cross-wizard">

            </mat-icon>
          </span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select (selectionChange)="updateNoUsage()" formControlName="mappedNoOfOrders">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>

          </mat-form-field>
          <span style="padding-left: 6px">
            <mat-radio-group [disabled]="drugFileInfoForm.get('noUsage').value==true" formControlName="usageValue"
              aria-label="Number of Orders">
              <mat-radio-button [value]="1" [checked]="drugFileInfoForm.get('orderOrUsage').value  == 2">
                Prescriptions Usage</mat-radio-button>
              <mat-radio-button style="padding-left: 6px" [value]="2" aria-label="Unit Usage"
                [checked]="drugFileInfoForm.get('orderOrUsage').value  == 1"> Pill
                Usage</mat-radio-button>

            </mat-radio-group></span>
          <span class="help_icon" matTooltip="This is the total number of Pills the pharmacy has dispensed. Requirements - numeric values only" matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 3 || this.deviceId.value === 6">
          <span>
            <mat-icon class="cross-wizard">

            </mat-icon>
          </span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedSecondaryDrugName">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span class="secondary-drug-name-label"> = Secondary Drug Name
          </span>
        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 1 || this.deviceId.value === 4 || this.deviceId.value === 5 || this.deviceId.value === 3 || this.deviceId.value === 6">
          <span>
            <mat-icon class="cross-wizard">

            </mat-icon>
          </span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedMnemonic" (selectionChange)="isSelecteMappedMnomonic()">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug?.name">{{drug?.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Customer Mnemonic </span>
          <span class="help_icon" matTooltip="a unique number for a drug assigned by a specific customer." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>


        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 4">
          <span>
            <mat-icon class="cross-wizard">

            </mat-icon>
          </span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedExternalDrugFlag">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug?.name">{{drug?.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = External Drug Flag </span>
          <span class="help_icon" matTooltip="This Field is used to define drugs that should be considered for use outside a Counting Device.
          a Y or Yes in this column tells the Forumulary tool you do not want the drug to be in a container it will instead be placed in a tray.
          a X in this field tells the Forumulary tool that this drug should not be placed in the device at all.
          " matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 1 || this.deviceId.value === 5">
          <span>
            <mat-icon class="cross-wizard">
              <img *ngIf="drugFileInfoForm.get('noUsage').value == true" src="/assets/img/icons/ico.16.warning.svg"
                alt="Warning">
            </mat-icon>
          </span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select [disabled]="isSuperCellSelectDisabled()"
              formControlName="mappedSuperCellSelect">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug?.name">{{drug?.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Super Cell Select </span>
          <span class="help_icon" matTooltip="This option is for no usage Max implementations when the user manually assigns super cells to specific locations in the Max. • Requirements - create a new column with a Y next to any drug the user wants a super cell for." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 1 || this.deviceId.value === 5">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedLockingCell">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Locking Cell Select</span>
          <span class="help_icon" matTooltip="This option is for no usage Max implementations when the user manually assigns locking cells to specific regular and super locations in the Max. • Requirements - create a new column with a Y next to any drug the user wants a locking cell for." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 1 || this.deviceId.value === 2 || this.deviceId.value === 3 || this.deviceId.value === 4 || this.deviceId.value === 5 || this.deviceId.value === 6">
          <span>
            <mat-icon class="cross-wizard">

            </mat-icon>
          </span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedRanking">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>

          </mat-form-field>

          <span style="padding-left: 6px"> = Ranking</span>
          <span class="help_icon" matTooltip="this field is for Pharmacies that have no usage information to determine what their most preferred drugs are. • Requirements - • the user must add and map a column. • with the Ranking of each drug the most preferred marked with 1 ascending to the least preferred." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 3 || this.deviceId.value === 4 || this.deviceId.value === 6">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedAtpLot">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>

          </mat-form-field>

          <span style="padding-left: 6px"> = Customer Lot#</span>
          <span class="help_icon" matTooltip="an Inventory control number assigned by the customer. This will be exported directly to the appropriate Documents." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 3 || this.deviceId.value == 6">

          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedAtpDrugExpirationDate">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Customer Drug Expiration Date</span>
          <span class="help_icon" matTooltip="a drug use by date assigned by the customer. This will be exported directly to the appropriate Documents.Format: MM/DD/YYYY" matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>       
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 3 || this.deviceId.value == 4 || this.deviceId.value === 6">

          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedCustomerQuantity">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Customer Quantity</span>
          <span class="help_icon" matTooltip="The Number of Pills the Customer has loaded into the Canisters." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 3 || this.deviceId.value === 6">
          <!--
          <span>
            <mat-icon class="cross-wizard">
              <img *ngIf="drugFileInfoForm.get('noUsage').value == true" src="/assets/img/icons/ico.asterisk.svg"
                alt="">
            </mat-icon>
          </span>
          -->
          <span> <mat-icon class="cross-wizard">
          </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedAtpDeviceLocation">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Canister Location</span>
          <span class="help_icon" matTooltip="This number assigns a drug directly to a specific location inside a device. This will be exported directly to the appropriate Documents." matTooltipPosition="after"
             matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 3 || this.deviceId.value === 4 || this.deviceId.value === 6">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedAtpPillDescription">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Customer Pill Description</span>
          <span class="help_icon" matTooltip="a customer assigned pill description, This will be exported directly to the appropriate Documents." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 3 || this.deviceId.value === 6">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedAtpPillColor">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Customer Pill Color</span>
          <span class="help_icon" matTooltip="A customer provided Drug color - This will be exported directly to the appropriate Documents. " matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 3 || this.deviceId.value === 4 || this.deviceId.value === 6">

          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedAtpPillShape">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Customer Pill Shape</span>
          <span class="help_icon" matTooltip="A customer provided Pill Shape - This will be exported directly to the appropriate Documents. " matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>
      <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 3 || this.deviceId.value === 6">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedAtpImp1">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>

          </mat-form-field>

          <span style="padding-left: 6px"> = Customer Pill Imprint 1</span>
          <span class="help_icon" matTooltip="A customer provided Imprint - This will be exported directly to the appropriate Documents." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 3 || this.deviceId.value === 6">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedAtpImp2">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Customer Pill Imprint 2</span>
          <span class="help_icon" matTooltip="A customer provided Imprint - This will be exported directly to the appropriate Documents." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 3 || this.deviceId.value === 6">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedCustomerBarcode">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> =Customer Barcode</span>
          <span class="help_icon" matTooltip="A customer provided Barcode to uniquely Identify a Drug  - This will be exported directly to the appropriate fields & Documents. " matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>


        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 1 || this.deviceId.value === 3 || this.deviceId.value === 4 || this.deviceId.value === 5 || this.deviceId.value ===6">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedCustomerOtc">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Customer OTC</span>
          <span class="help_icon" matTooltip="a customer assigned OTC drug. • Requirements - create a new column with a Y next to any drug the user wants to assign as OTC drug." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 3 || this.deviceId.value ===6">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedCustomerComment">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Customer Comment</span>
          <span class="help_icon" matTooltip="A customer provided Comment - This will be exported directly to the appropriate Documents. " matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 3 || this.deviceId.value ===6">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedCustomerInventoryNumber">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Customer Inventory Number</span>
          <span class="help_icon" matTooltip="A customer provided Inventory Number - This will be exported directly to the appropriate fields & Documents. " matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value !== 7">
          <span>
            <mat-icon class="cross-wizard">

            </mat-icon>
          </span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedStrength">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug?.name">{{drug?.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Drug Strength </span>
          <span class="help_icon" matTooltip="This is defining the customer's drug strength as reference, format should be the strength value concatenated with unit of measure, e.g- 10 mg" matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 4">
          <span>
            <mat-icon class="cross-wizard">

            </mat-icon>
          </span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedAhsfClass">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug?.name">{{drug?.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span class="drug-number-label"> = AhsfClass </span>
          <span class="help_icon" matTooltip="AHSF class for the drug." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 4">
          <span>
            <mat-icon class="cross-wizard">

            </mat-icon>
          </span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedCost">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug?.name">{{drug?.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span class="drug-number-label"> = Cost </span>
          <span class="help_icon" matTooltip="Cost value for the drug." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 4">
          <span>
            <mat-icon class="cross-wizard">

            </mat-icon>
          </span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedPackageOrderNumber">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug?.name">{{drug?.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span class="drug-number-label"> = PackageOrderNumber </span>
          <span class="help_icon" matTooltip="Package order number for the drug." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 3 || this.deviceId.value === 6">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select [disabled]="isDisabledHccAndScc()" formControlName="mappedAtpHighCapCanister">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = High-Capacity Canister Select</span>
          <span class="help_icon" matTooltip="This option is for the user to manually assign High-Capacity Canister Select to specific locations in the ATP. • Requirements - create a new column with a Y next to any drug the user wants a High capacity Canister for." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 3 || this.deviceId.value === 6">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select  [disabled]="isDisabledHccAndScc()" formControlName="mappedAtpSmartCanister">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Smart Canister Select</span>
          <span class="help_icon" matTooltip="This option is for the user to manually assign Smart Canister Select to specific locations in the ATP. • Requirements - create a new column with a Y next to any drug the user wants a Smart capacity Canister for." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>




        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 4">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select  formControlName="mappedLid">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Lid</span>
          <span class="help_icon" matTooltip="Use this option to manually assign a LID in Synmed. The input value should be in the format 'S100'." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

         <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 4">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select  formControlName="mappedLidVolcanic">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Lid Volcanic</span>
          <span class="help_icon" matTooltip="Use this option to manually assign a Lid Volcanic in Synmed. The input value should be 'Y' or 'N'." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

         <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 4">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select  formControlName="mappedPipetteSize">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Pipette Size</span>
          <span class="help_icon" matTooltip="Use this option to manually assign a Pipette Size in Synmed. The input value should be '1' or '2'." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

         <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 4">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select  formControlName="mappedToggleFlag">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Toggle Flag</span>
          <span class="help_icon" matTooltip="Use this option to manually assign a Toggle Flag in Synmed. The input value should be 'Y' or 'N'" matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

         <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 4">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select  formControlName="mappedMassIndex">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Mass Index</span>
          <span class="help_icon" matTooltip="Use this option to manually assign a Mass Index in Synmed. The input value should be '0', '1', '2' or '3'" matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

         <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 4">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select  formControlName="mappedContainerId">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Container Id</span>
          <span class="help_icon" matTooltip="Use this option to manually assign a Container Id in Synmed. The input value should be in the format '277'." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

         <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 4">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select  formControlName="mappedFragileFlag">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Fragile Flag</span>
          <span class="help_icon" matTooltip="Use this option to manually assign a Fragile Flag in Synmed. The input value should be 'Y' or 'N'." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

         <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 4">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select  formControlName="mappedContainerSize">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Container Size</span>
          <span class="help_icon" matTooltip="Use this option to manually assign a Container Size in Synmed. The input value should be 'G' or 'P'" matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

         <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 4">
          <span> <mat-icon class="cross-wizard">

            </mat-icon></span>

          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select  formControlName="mappedCustomerUpc">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <span style="padding-left: 6px"> = Customer UPC</span>
          <span class="help_icon" matTooltip="Use this option to manually assign a Customer UPC in Synmed. The input value should be in the format '300935863024'." matTooltipPosition="after"
            matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Product ID -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedProductId">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Product ID</span>
          <span class="help_icon" matTooltip="Unique product identifier from Legacy Connect." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Product scan code -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedProductScanCode">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Product Scan Code</span>
          <span class="help_icon" matTooltip="Barcode or scan code used to identify the product in Legacy Connect." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- GTIN -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedGtin">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = GTIN</span>
          <span class="help_icon" matTooltip="Global Trade Item Number used to identify the product package." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Pack Size -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedPackSize">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Pack Size</span>
          <span class="help_icon" matTooltip="Number of units in the product package." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Purchase Qty -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedPurchaseQty">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Purchase Qty</span>
          <span class="help_icon" matTooltip="Purchase quantity for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Drug Schedule -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedDrugSchedule">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Drug Schedule</span>
          <span class="help_icon" matTooltip="Drug schedule classification for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Drug Form -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedDrugForm">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Drug Form</span>
          <span class="help_icon" matTooltip="Dosage form for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Product Type -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedProductType">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Product Type</span>
          <span class="help_icon" matTooltip="Type or category of the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- UomClass -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedUomClass">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = UomClass</span>
          <span class="help_icon" matTooltip="Unit of measure class for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Sell UOM -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedSellUom">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Sell UOM</span>
          <span class="help_icon" matTooltip="Unit of measure used when selling the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Capacity -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedCapacity">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Capacity</span>
          <span class="help_icon" matTooltip="Container or package capacity for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- EXP Date -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedExpDate">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = EXP Date</span>
          <span class="help_icon" matTooltip="Expiration date for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- ORMD -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedOrmd">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = ORMD</span>
          <span class="help_icon" matTooltip="ORM-D indicator for regulated materials." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Refrigerate Flag -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedRefrigerateFlag">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Refrigerate Flag</span>
          <span class="help_icon" matTooltip="Indicates whether the product requires refrigeration." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Is Oral Solid -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedIsOralSolid">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Is Oral Solid</span>
          <span class="help_icon" matTooltip="Indicates whether the product is an oral solid medication." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Slot Area -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedSlotArea">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Slot Area</span>
          <span class="help_icon" matTooltip="Slot area for the product location." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Slot Shelf -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedSlotShelf">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Slot Shelf</span>
          <span class="help_icon" matTooltip="Slot shelf for the product location." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Slot Bin -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedSlotBin">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Slot Bin</span>
          <span class="help_icon" matTooltip="Slot bin for the product location." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Loc Type -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedLocType">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Loc Type</span>
          <span class="help_icon" matTooltip="Location type for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- ROP -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedRop">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = ROP</span>
          <span class="help_icon" matTooltip="Reorder point for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Qty on Shelf -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedQtyonShelf">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Qty on Shelf</span>
          <span class="help_icon" matTooltip="Quantity on shelf for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Lot No -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedLotNo">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Lot No</span>
          <span class="help_icon" matTooltip="Lot number for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Vial Size -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedVialSize">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Vial Size</span>
          <span class="help_icon" matTooltip="Vial size for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Vial Capacity -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedVialCapacity">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Vial Capacity</span>
          <span class="help_icon" matTooltip="Vial capacity for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Vial Enabled -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedVialEnabled">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Vial Enabled</span>
          <span class="help_icon" matTooltip="Indicates whether vial handling is enabled for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Vendor Part No -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedVendorPartNo">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Vendor Part No</span>
          <span class="help_icon" matTooltip="Vendor part number for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Specialty -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedSpecialty">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Specialty</span>
          <span class="help_icon" matTooltip="Specialty indicator or category for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Rank -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedRank">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Rank</span>
          <span class="help_icon" matTooltip="Rank value for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- NA -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedNA">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = NA</span>
          <span class="help_icon" matTooltip="NA value for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Thirty Dram Capacity -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedThirtyDramCapacity">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Thirty Dram Capacity</span>
          <span class="help_icon" matTooltip="Thirty dram capacity for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Max Recommended for Use -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedMaxRecomendedforUse">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Max Recommended for Use</span>
          <span class="help_icon" matTooltip="Indicates whether the product is recommended for Max use." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Cell Capacity Small -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedCellCapacitySmall">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Cell Capacity Small</span>
          <span class="help_icon" matTooltip="Small cell capacity for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>

        <!-- Cell Capacity Large -->
        <div class="flex justify-start content-center items-center flex-row" *ngIf="this.deviceId.value === 7">
          <span><mat-icon class="cross-wizard"></mat-icon></span>
          <mat-form-field floatLabel="never" class="sm:basis-1/4 basis-1/4">
            <mat-select formControlName="mappedCellCapacityLarge">
              <mat-option *ngFor="let drug of columnNameList" [value]="drug.name">{{drug.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span style="padding-left: 6px"> = Cell Capacity Large</span>
          <span class="help_icon" matTooltip="Large cell capacity for the product." matTooltipPosition="after" matTooltipClass="custom_tooltip">
            <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
          </span>
        </div>      

      <mat-card appearance="outlined" *ngIf="errorMessages.length>0" style="height: 150px;">
        <h5 style="margin: 10px 25px 1px 37px;">
          <div class="flex justify-start content-center items-center flex-row">
            <div class="flex flex-row justify-start content-stretch items-stretch h-full basis-1/2">
              Error Messages
            </div>
            <div class="flex flex-row justify-end content-stretch items-stretch h-full basis-1/2">
              <mat-icon class="cross-wizard error-icon flex flex-row justify-end content-end items-end h-full"
                (click)="this.errorMessages=[]" aria-hidden="true">cancel</mat-icon>
            </div>
          </div>

        </h5>
        <mat-card-content style="text-align: center; height: 120px; overflow: scroll;">

          <mat-error *ngFor="let item of errorMessages">
            <span *ngIf="item.length>0">{{ item }}</span>
          </mat-error>

        </mat-card-content>
      </mat-card>

      <mat-dialog-actions class="flex justify-end content-end items-end flex-row">
        <button mat-button class="btn-danger  btn-md" (click)="drugFileInfoForm.reset(); valueSetAfterResetForm()"
          id="Reset" type="button" aria-label="Reset">Reset All</button>
        <button mat-button class="btn-primary  btn-md" (click)="closeWizard.emit(true)" id="Cancel"
          type="button" aria-label="Cancel">Cancel</button>
        <button mat-button [ngClass]="{'btn-blue':drugFileInfoForm.valid, 'btn-disabled':!drugFileInfoForm.valid}"
          [disabled]="!drugFileInfoForm.valid" class=" btn-md btn-done m-l-16" (click)="isOpenAlertWizard()" type="button"
          aria-label="Next">Next</button>
      </mat-dialog-actions>
      </mat-dialog-content>
    </form>

  </div>




<!---END: Wizard First Screen-->


